<template>
  <!-- 議案總表 -->
  <div id="TopicEditDialog_main">
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="60%"
    >
      <el-form
        ref="topicEditFrom"
        :model="data"
        :rules="rules"
        label-position="right"
        label-width="120px"
      >
        <el-form-item
          label="議案標題"
          prop="title"
        >
          <el-input
            v-model="data.title"
            :rows="3"
            type="textarea"
            placeholder="請輸入議案標題"
            maxlength="100"
            show-word-limit
          />
        </el-form-item>
        <el-form-item label="議案說明">
          <el-input
            v-model="data.description"
            :rows="5"
            type="textarea"
            placeholder="請輸入議案說明"
            maxlength="300"
            show-word-limit
          />
        </el-form-item>
        <el-form-item
          label="出席門檻"
          prop="attendanceThreshold"
        >
          <el-input-number
            v-model="data.attendanceThreshold"
            :precision="2"
            :step="1"
            :min="1"
            :max="100"
          />
          <span class="percentage">％</span>
        </el-form-item>
        <el-form-item label="投票門檻">
          <el-input-number
            v-model="data.consentThreshold"
            :precision="2"
            :step="1"
            :min="1"
            :max="100"
          />
          <span class="percentage">％</span>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button
          round
          @click="dialogVisible = false"
        >
          取消
        </el-button>
        <el-button
          type="primary"
          round
          @click="submit"
        >
          儲存
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="異動原因"
      :visible.sync="editNotedialogVisible"
      width="40%"
      @open="canClickButton = true"
      @closed="canClickButton = true"
    >
      <el-input
        v-model="editNote"
        :rows="5"
        :class="editNoteError ? 'error' : ''"
        type="textarea"
        placeholder="請輸入異動原因"
        maxlength="100"
        show-word-limit
        @input="editNoteChange"
      />
      <p
        v-if="editNoteError"
        class="editNoteError"
      >
        請輸入異動原因
      </p>
      <div slot="footer">
        <el-button
          round
          @click="editNotedialogVisible = false"
        >
          取消
        </el-button>
        <el-button
          type="primary"
          round
          @click="updateTopic"
        >
          送出
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    mainThreshold: Number
  },
  data () {
    return {
      errorMsg: {
        TOPIC_TITLE: '請輸入議案標題',
        ATTENDANCE_THRESHOLD: '議案出席門檻應 ≥ 會議出席門檻',
        ATTENDANCE_THRESHOLD_SHORT: '應 ≥ 會議出席門檻'
      },
      dialogTitle: '',
      dialogVisible: false,
      editNotedialogVisible: false,
      data: {},
      editNote: '',
      editNoteError: false,
      rules: {
        title: [
          { required: true, validator: this.titleValidator, trigger: 'blur' }
        ],
        attendanceThreshold: [
          { validator: this.attendanceThresholdValidator, trigger: 'blur' }
        ]
      },
      canClickButton: true // 防止連點button參數
    }
  },
  methods: {
    openDialog (data) {
      this.dialogVisible = true
      this.editNote = ''
      this.canClickButton = true
      if (data) {
        console.log(data)
        this.dialogTitle = '編輯議案'
        this.data = data
      } else {
        this.dialogTitle = '新增臨時議案'
        this.data = {
          title: '',
          description: '',
          attendanceThreshold: 50,
          consentThreshold: 50
        }
      }
    },
    submit () {
      if (!this.canClickButton) { return }
      this.canClickButton = false
      this.$refs.topicEditFrom.validate((valid) => {
        if (valid) {
          // eslint-disable-next-line eqeqeq
          if (this.dialogTitle == '編輯議案') { this.editNotedialogVisible = true } else { this.addOneTopic() }
        } else {
          this.canClickButton = true
          return false
        }
      })
    },
    editNoteChange () {
      // eslint-disable-next-line eqeqeq
      this.editNoteError = !!((this.editNote == undefined || this.editNote == '' || this.editNote == null))
      if (!this.editNoteError) { this.editNoteError = new RegExp('^[ ]+$').test(this.editNote) }
      return !this.editNoteError
    },
    // 送出編輯議案
    async updateTopic () {
      if (!this.canClickButton) { return }
      this.canClickButton = false
      const check = await this.editNoteChange()
      console.log(check)
      if (check) {
        apiUnitOwnerAssembly.Topic.UpdateTopic(
          {
            assemblyId: this.$route.params.id,
            topicId: this.data.id,
            editNote: this.editNote,
            topicDto: {
              title: this.data.title,
              description: this.data.description,
              attendanceThreshold: this.data.attendanceThreshold / 100,
              consentThreshold: this.data.consentThreshold / 100
            }
          }
        ).then(res => {
          if (res.status === 200) {
            this.$message.success('議案編輯成功')
            this.$emit('refresh', this.data.id)
            this.dialogVisible = false
            this.editNotedialogVisible = false
          }
        }).catch((err) => {
          this.editNote = ''
          setTimeout(() => {
            this.canClickButton = true
          }, 2000)
          console.log('錯誤訊息：', err.response)
          if (err.response && err.response.status >= 400) { this.$message.error('發生未知錯誤，請稍後再試') }
        })
      } else {
        this.canClickButton = true
      }
    },
    // 新增臨時議案
    addOneTopic () {
      // 原先的做法會讓使用者看到送出前百分比數值將變為 1.00%，擔心造成困惑，因而 copy 為新的物件再改值送出
      const dataWithPercentage = {
        ...this.data,
        attendanceThreshold: this.data.attendanceThreshold / 100,
        consentThreshold: this.data.consentThreshold / 100
      }
      apiUnitOwnerAssembly.Topic.CreateTopic(
        {
          assemblyId: this.$route.params.id,
          topicDto: dataWithPercentage
        }
      ).then(res => {
        console.log(res)
        if (res.status === 200) {
          this.$message.success('議案新增成功')
          this.dialogVisible = false
          this.$emit('refresh')
        }
      }).catch((err) => {
        this.canClickButton = true
        console.log('錯誤訊息：', err.response)
        if (err.response && err.response.status >= 400) { this.$message.error('發生未知錯誤，請稍後再試') }
      })
    },
    titleValidator (rule, value, callback) {
      if (!value) {
        callback(new Error(this.errorMsg.TOPIC_TITLE))
      } else {
        callback()
      }
    },
    attendanceThresholdValidator (rule, value, callback) {
      console.log('attendanceThresholdValidator', value)
      if (value < this.mainThreshold) {
        callback(new Error(this.errorMsg.ATTENDANCE_THRESHOLD_SHORT + `（${this.mainThreshold}%）`))
      } else {
        callback()
      }
    }
  }
}
</script>
<style lang="sass" scoped>
#TopicEditDialog_main
  ::v-deep .el-dialog
    +basicDialog
    min-width: 540px
    .el-dialog__body
      .el-form
        text-align: left
        .el-form-item
          margin-bottom: 30px
          &:nth-last-child(1)
            margin-bottom: 0
          &.is-success .el-input__inner
            border-color: $borderDark1
          .el-form-item__label
            font-weight: bold
            margin-right: 0
            padding-right: 32px
        .el-input-number
          width: 80px
          .el-input-number__decrease,.el-input-number__increase
            display: none
          .el-input
            .el-input__inner
              font-weight: bold
              font-size: 18px
              letter-spacing: 2px
              padding-right: 0
              padding-left: 0
        .percentage
          position: relative
          margin-left: 5px
    .el-dialog__footer
      text-align: center
    .el-textarea.error
      .el-textarea__inner
        border-color: $dangerColor
    .editNoteError
      color: $dangerColor
      font-size: 12px
      text-align: left
      margin-top: 10px
</style>
